export default "assets/images/41b2cf0fa604d3f196ca52337d238219.jpg";